export default __webpack_public_path__ + "static/media/arco-ameaca.441f18cc.webp";